export default "__VITE_ASSET__DxA332OL__"